import { render } from "./PresentationStat.vue?vue&type=template&id=c2eb68a2"
import script from "./PresentationStat.vue?vue&type=script&lang=js"
export * from "./PresentationStat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__